export const MODEL_INPUT_TYPE = {
  AMINO_ACID_SEQUENCE: 'amino_acid_sequence',
  ANTIBODY: 'antibody',
  MOLECULE: 'molecule',
} as const;

export const MODEL_INPUT_FIELD_VALUE_TYPE = {
  AMINO_ACID_SEQUENCE: 'amino_acid_sequence',
  MOLECULE: 'molecule',
} as const;

export interface ModelInputFieldDefinition {
  displayName: string;
  key: string;
  valueType: string;
}

export interface ModelInputTypeDefinition {
  displayName: string;
  fields: Array<ModelInputFieldDefinition>;
  type: string;
}

const MODEL_INPUT_TYPE_DEFINITIONS: Record<string, ModelInputTypeDefinition> = {
  [MODEL_INPUT_TYPE.AMINO_ACID_SEQUENCE]: {
    displayName: 'AA sequence',
    fields: [
      {
        displayName: 'AA sequence',
        key: 'sequence',
        valueType: MODEL_INPUT_FIELD_VALUE_TYPE.AMINO_ACID_SEQUENCE,
      },
    ],
    type: MODEL_INPUT_TYPE.AMINO_ACID_SEQUENCE,
  },
  [MODEL_INPUT_TYPE.ANTIBODY]: {
    displayName: 'Antibody',
    fields: [
      {
        displayName: 'Heavy chain',
        key: 'heavy_chain',
        valueType: MODEL_INPUT_FIELD_VALUE_TYPE.AMINO_ACID_SEQUENCE,
      },
      {
        displayName: 'Light chain',
        key: 'light_chain',
        valueType: MODEL_INPUT_FIELD_VALUE_TYPE.AMINO_ACID_SEQUENCE,
      },
    ],
    type: MODEL_INPUT_TYPE.ANTIBODY,
  },
  [MODEL_INPUT_TYPE.MOLECULE]: {
    displayName: 'Molecule',
    fields: [
      {
        displayName: 'Molecule',
        key: 'molecule',
        valueType: MODEL_INPUT_FIELD_VALUE_TYPE.MOLECULE,
      },
    ],
    type: MODEL_INPUT_TYPE.MOLECULE,
  },
};

export function getModelInputTypeDefinition(inputType: string): ModelInputTypeDefinition | null {
  return MODEL_INPUT_TYPE_DEFINITIONS[inputType] ?? null;
}
